import styled from '@emotion/styled';
import { primary } from '@styles/Colors';
import Link, { LinkProps } from 'next/link';

const LinkWrapper = styled.span<{ fontSize: number; fontColor: string }>`
  display: flex;

  a {
    color: ${(props) => props.fontColor};

    font-family: Pretendard;
    font-size: ${(props) => props.fontSize}px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.28px;
    text-decoration-line: underline;
  }
`;

type Props = LinkProps & {
  readonly fontSize?: number;
  readonly fontColor?: string;
  readonly children?: React.ReactNode;
};

export default function LinkText({ fontSize = 14, fontColor = primary.blue, children, ...linkProps }: Props) {
  return (
    <LinkWrapper fontSize={fontSize} fontColor={fontColor}>
      <Link {...linkProps}>{children}</Link>
    </LinkWrapper>
  );
}
